import {
    createBaseThemeOptions,
    createUnifiedTheme,
    palettes,
  } from '@backstage/theme';
  
  export const VCATheme = createUnifiedTheme({
    ...createBaseThemeOptions({
      palette: palettes.light,
    }),
    defaultPageTheme: 'home',
  });